import * as THREE from "three";

export function createRenderer(canvas, options = {}) {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
    alpha: options.alpha ?? false,
    powerPreference: "high-performance",
  });

  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(
    options.width ?? window.innerWidth,
    options.height ?? window.innerHeight
  );
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = options.exposure ?? 1.15;

  if (options.alpha) {
    renderer.setClearColor(0x000000, 0);
  }

  return renderer;
}
